















import Vue from "vue";
export default Vue.extend({
  name: "CheckboxGroup",

  model: {
    prop: "checked",
    event: "change"
  },

  props: {
    label: {
      type: String,
      required: false
    },
    checked: {
      type: Boolean
    },
    color: {
      type: String,
      required: false
    }
  },

  data: () => {
    return {
      id: ""
    };
  },

  created(): void {
    this.id = `form-group-${this._uid}`;
  },

  computed: {
    checkboxStyles(): Record<string, string> {
      return {
        color: this.color || ""
      };
    }
  }
});
